import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/nav_ic_back@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-1ff1a8ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header_x",
  style: {"height":"44px"}
}, null, -1))
const _hoisted_3 = {
  class: "header_header",
  style: {"height":"44px"}
}

import { watch, ref } from 'vue'
    import { useRouter, useRoute } from 'vue-router'

    
export default /*#__PURE__*/_defineComponent({
  props: {
        pathList: {
            type: Array,
            required: false,
            default: []
        }
    },
  setup(__props) {

const props = __props

    const router = useRouter()

    const route = useRoute()

    let currentPath = ref<string>('')

    let isShow = ref<boolean>(false)

    

    // 返回上一页
    const previousPage = () => {
        router.go(-1)
    }

    // 监听路由是否需要显示返回按钮
    watch(() => route.path, (path, oldPath) => {
        let res = props.pathList.find(item => {
            return item === path
        })
        currentPath.value = route.path
        isShow.value = !res;
    }, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      (_unref(isShow) && _unref(currentPath) !== '/logInAgain')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            onClick: previousPage,
            src: _imports_0,
            alt: ""
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})